import styled, { css } from 'styled-components';
import {
  lightenDarkenColor,
  Button,
} from 'components/project/ClerkScreen/shared/utils/styles';

export const Layout = styled.div`
  display: grid;
  height: 100%; //100vh;
  grid-template-rows: 40px 60px 50px 290px 50px fit-content(100%);
  grid-template-columns:
    50px minmax(273px, 1fr) minmax(273px, 1.25fr) minmax(275px, 1fr)
    minmax(345px, 1.5fr);
  grid-template-areas:
    'snav tbar tbar tbar tbar tbar'
    'snav pnav pnav pnav logo .'
    'snav title status status chat .'
    'snav details strt askbid chat .'
    'snav details binc askbid chat .'
    'snav details binc fbtns chat .';
  grid-gap: 10px;
  overflow: hidden;
`;

export const PageNavContainer = styled.div`
  grid-area: pnav;
  display: flex;
  height: 100vh;
  margin-left: -10px;
  padding: 0px 5px;
  & div {
    margin: 10px 5px;
    & button {
      height: 50px;
      width: 100%;
      font-size: 1em;
    }
  }
`;

export const AuctionStartContainer = styled.div`
  grid-area: strt;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 10px 0px;
  color: #000000;
  border: 1px solid gray;
  background-color: #eee;
`;

export const AskingBidContainer = styled.div`
  grid-area: askbid;
  background-color: #eee;
  padding: 5px;
  border: 1px solid gray;
  border-radius: 3px;
`;

export const HotKeyLabel = styled.div`
  position: absolute;
  bottom: 5px;
  right: 5px;
  font-size: 0.5em;
`;

export const BidButtonsContainer = styled.div``;

export const BidButton = styled(Button)`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  margin: 10px 0px;
  height: 75px;
  width: 100%;
  font-size: 1.6em;
  color: #ffffff;
  background-color: #008000;
  text-transform: uppercase;
  :disabled,
  :disabled:hover,
  :disabled i {
    cursor: not-allowed;
    background-color: #e7e7e7;
    color: #666;
  }
  &:hover {
    background-color: ${lightenDarkenColor('#008000', 20)};
    color: #ffffff;
  }
  & i {
    color: #ffffff;
    font-size: 1.5em;
    padding-right: 10px;
  }
  && ${HotKeyLabel} {
    font-size: 1rem;
    bottom: 0px;
  }
`;

export const BidModifyButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  & button {
    position: relative;
    width: 48%;
    height: 50px;
    font-size: 0.9em;
    border: 1px solid gray;
    border-radius: 3px;
    text-transform: uppercase;
    font-weight: bold;
    background-color: #0095E8;
    padding: 5px 10px;
    :disabled {
      cursor: not-allowed;
      background-color: #e7e7e7;
      color: #666;
    }
  }
  && ${HotKeyLabel} {
    font-size: 1.5rem;
    bottom: 0px;
  }
`;

export const DecisionButtonsContainer = styled.div`
  grid-area: fbtns;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #eee;
  border: 1px solid gray;
  padding: 0px 5px;
  text-transform: uppercase;
`;

const decisionButtonStyle = ({
  confirm, bgColor, bgVariance, color,
}) => {
  if (confirm) {
    return css`
      flex-direction: row;
      & button {
        font-size: 1em;
        margin: 1px;
        padding: 10px 8px;
        width: 100%;
        height: 50px;
        text-transform: uppercase;
        font-weight: normal;
        background-color: #ffffff;
        border: 1px solid #008000;
        color: #008000;
        &:hover {
          background-color: #008000;
          color: #ffffff;
        }
      }
    `;
  }

  return css`
    flex-direction: column;
    & button {
      background-color: ${bgColor};
      color: ${color};
      &:disabled,
      :disabled:hover {
        cursor: not-allowed;
        background-color: #e7e7e7;
        color: #666;
      }
      &:hover {
        background-color: ${lightenDarkenColor(bgColor, bgVariance ?? 20)};
        color: ${color};
      }
    }
  `;
};

export const ButtonWrapper = styled.div`
  display: flex;
  ${(props) => decisionButtonStyle(props)}
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  margin: 10px 0px;
`;

export const StyledCommitButton = styled(Button)`
  ${({ tabIndex, invalid }) => css`
    width: 100%;
    height: 50px;
    margin: 1px;
    padding: 10px 8px;
    font-size: 1em;
    tab-Index: ${tabIndex};
    ${invalid && 'cursor: not-allowed'};
  `};  
`;

export const AuctionContinuationButtonsContainer = styled.div`
  border: 0px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;


